document.addEventListener('DOMContentLoaded', () => {

    let imagesSliders = document.querySelectorAll('.images-sliders');
    if(imagesSliders){
        imagesSliders.forEach((item)=>{
            new Swiper(item, {
                rewind: true,
                effect: "fade",
                speed: 3000,
                fadeEffect: {
                    "crossFade": true
                },
                autoplay: {
                    delay: 6000,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: ".pagination-images",
                    clickable: true,
                },
                navigation: {
                    nextEl: ".sw-but-img-next",
                    prevEl: ".sw-but-img-prev",
                },
            });
        });
    }

    let swiperTop = document.querySelectorAll('.swiper-top');
    if(swiperTop){
        swiperTop.forEach((item)=>{
            new Swiper(item, {
                loop: true,
                effect: "fade",
                speed: 1000,
                fadeEffect: {
                    "crossFade": true
                },
                autoplay: {
                    delay: 80000,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: ".pagination-hero",
                    clickable: true,
                }
            });
        });
    }

    let gallerySlider = document.querySelectorAll('.gallery-slider');
    if(gallerySlider){
        gallerySlider.forEach((item)=> {
            new Swiper(item, {
                loop: true,
                effect: "fade",
                speed: 1000,
                uniqueNavElements: false,
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-gal-next",
                    prevEl: ".sw-gal-prev",
                },
                pagination: {
                    el: ".pagination-gallery",
                    clickable: true,
                }
            });
        });
    }

    let slideSlider = document.querySelectorAll('.slide-slider');
    if(slideSlider){
        slideSlider.forEach((item)=> {
            new Swiper(item, {
                loop: true,
                effect: "fade",
                speed: 1000,
                autoHeight: true,
                uniqueNavElements: false,
                fadeEffect: {
                    "crossFade": true
                },
                pagination: {
                    el: ".pagination-slider",
                    clickable: true,
                }
            });
        });
    }

    let reviewsSlider = document.querySelectorAll('.reviews-slider');
    if(reviewsSlider){
        reviewsSlider.forEach((item)=> {
            new Swiper(item, {
                loop: true,
                effect: "fade",
                speed: 1000,
                autoHeight: true,
                uniqueNavElements: false,
                autoplay: {
                    delay: 6000,
                    disableOnInteraction: false,
                },
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-but-next",
                    prevEl: ".sw-but-prev",
                }
            });
        });
    }

    let bitterSlider = document.querySelectorAll('.bitter-slider');
    if(bitterSlider){
        bitterSlider.forEach((item)=> {
            new Swiper(item, {
                loop: true,
                effect: "fade",
                speed: 1000,
                autoHeight: true,
                fadeEffect: {
                    "crossFade": true
                },
                pagination: {
                    el: ".pagination-bitter",
                    clickable: true,
                }
            });
        });
    }

});